import { ColumnDef } from '@tanstack/react-table';
import { ArrowUpDown } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { PlannerConfigEntity } from '@/services/configurator/PlannerConfigTypes';
import { formattedDate } from '@/utils/date';
import { PlannerEnv } from '@/utils/env';
import { PlannerListNavigation } from './PlannerListNavigation';

export const columns = (env: PlannerEnv): ColumnDef<PlannerConfigEntity>[] => [
  {
    accessorKey: 'identifier',
    header: ({ column }) => {
      return (
        <Button
          variant='ghost'
          onClick={() => column.toggleSorting(column.getIsSorted() === 'asc')}
        >
          Identifier
          <ArrowUpDown className='ml-2 h-4 w-4' />
        </Button>
      );
    },
    cell: ({ row }) => {
      return (
        <div className='text-left font-medium'>
          {row.getValue('identifier')}
        </div>
      );
    },
  },
  {
    accessorKey: 'lastModified',
    header: ({ column }) => {
      return (
        <Button
          variant='ghost'
          onClick={() => column.toggleSorting(column.getIsSorted() === 'asc')}
        >
          Last modified
          <ArrowUpDown className='ml-2 h-4 w-4' />
        </Button>
      );
    },
    cell: ({ row }) => {
      const dateString: string = row.getValue('lastModified');

      return (
        <div className='text-left font-medium'>{formattedDate(dateString)}</div>
      );
    },
    meta: { hiddenOnMobile: true },
  },
  {
    accessorKey: 'plannerContact',
    header: ({ column }) => {
      return (
        <Button
          variant='ghost'
          onClick={() => column.toggleSorting(column.getIsSorted() === 'asc')}
        >
          Planner Contact
          <ArrowUpDown className='ml-2 h-4 w-4' />
        </Button>
      );
    },
    cell: ({ row }) => {
      return (
        <div className='text-left font-medium'>
          {row.getValue('plannerContact')}
        </div>
      );
    },
    meta: { hiddenOnMobile: true },
  },
  {
    accessorKey: 'modifiedBy',
    header: ({ column }) => {
      return (
        <Button
          variant='ghost'
          onClick={() => column.toggleSorting(column.getIsSorted() === 'asc')}
        >
          Modified By
          <ArrowUpDown className='ml-2 h-4 w-4' />
        </Button>
      );
    },
    cell: ({ row }) => {
      return (
        <div className='text-left font-medium'>
          {row.getValue('modifiedBy')}
        </div>
      );
    },
    meta: { hiddenOnMobile: true },
  },
  {
    id: 'edit',
    enableHiding: false,
    cell: ({ row }) => {
      const planner = row.original;

      return <PlannerListNavigation env={env} planner={planner} />;
    },
  },
];
